import { isNud } from '@/shared/utilities/typing'

/**
 * アプリ エンティティ
 */
class App {
    app_key;
    app_name;
    unit_price;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }
        
        this.app_key = properties.app_key;
        this.app_name = properties.app_name;
        this.unit_price = properties.unit_price;
    }
}

export default App;
